<svelte:options
	customElement={{
		tag: 'rf-legend',
		shadow: 'open', // shadow: 'open'
	}}
/>

<script lang="ts">
	/**
	 * Import
	 */
	import classNames from 'classnames';
	import parseBool from '@src/utils/bool';
	import { v4 as uuidv4 } from 'uuid';
	import { useSlottedElements } from '@src/composables/useSlottedElements';

	/**
	 * Props
	 */
	const { full = false } = $props();

	/**
	 * Constants
	 */
	const componentId = uuidv4();

	/**
	 * Composables
	 */

	const { element, forEachSlottedNode } = useSlottedElements();

	/**
	 * Methods
	 */

	export const getUUID = (): string => {
		return componentId;
	};

	export const getMeta = (): object => {
		let title,
			description,
			source,
			content = '';

		forEachSlottedNode((node) => {
			let item = node as HTMLElement;

			if (item.tagName === 'RF-TEXT' && item.getAttribute('type') === 'title') title = item.innerText;
			else if (item.tagName === 'RF-TEXT' && item.getAttribute('type') === 'description') description = item.innerText;
			else if (item.tagName === 'RF-TEXT' && item.getAttribute('type') === 'source') source = item.innerText;
			else {
				if (item.TEXT_NODE) content += sanitize(item.textContent);
				else content += sanitize(item.outerHTML);
			}
		}, '*');

		return {
			title,
			description,
			source,
			content,
		};
	};

	const sanitize = (string: string | null = '') => {
		return string
			?.replace(/\r?\n[\t ]*/g, ' ') // replace newlines + following tabs/spaces with a single space
			.replace(/\s{2,}/g, ' ');
	};
</script>

<div id={componentId} bind:this={$element} class={classNames('rf-legend', { 'rf-legend--full': parseBool(full) })} part="rf-legend">
	<slot></slot>
</div>

<style lang="scss" global>
	.rf-legend {
		padding: var(--rf-spacing-xs, 4px);
		font-family: var(--rf-body-font);
		font-size: var(--rf-small-body-font-size, 14px);
		background-color: var(--rf-main-bg-color, rgba(255, 255, 255, 0.5));
		color: var(--rf-primary-font-color, black);

		&--full {
			width: 100%;
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
		}

		::slotted(rf-text) {
			display: block;
		}
		::slotted(*:not(:last-child)) {
			margin-bottom: 8px;
		}

		::slotted(rf-text[type='title']) {
			--rf-h1-font-size: 1.2rem;
			font-weight: bold;
		}

		::slotted(rf-text[type='subtitle']) {
			font-size: 1rem;
		}

		::slotted(rf-text[type='source']) {
			font-style: italic;
		}
	}
</style>
